import classnames from 'classnames';
import React, { FC, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { CustomModalLayout } from '@wix/design-system';
import { HELP_LINKS } from '../../../constants/HelpLinks';
import { attachEnableDebugHandler, detachEnableDebugHandler } from '../../../services/Logger/Logger';
import { isSafari10 } from '../../../utils/userAgent';
import { useHelpLink } from '../HelpLink/useHelpModal';
import { useOpenedModal } from '../../../utils/hooks/useModal/useModal';
import { isTargetInputField } from '../../../utils/dom/domEvents';
import styles from './RootModal.scss';
import { IOuter } from './RootModal.types';

export const RootModal: FC<IOuter> = ({ children, onCancel }) => {
  const { openedModal } = useOpenedModal();

  useEffect(() => {
    attachEnableDebugHandler();

    return () => {
      detachEnableDebugHandler();
    };
  }, []);

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !openedModal && !isTargetInputField(event)) {
        onCancel();
      }
    };

    window.addEventListener('keydown', handleEscKey);

    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [onCancel, openedModal]);

  const { formatMessage } = useIntl();
  const { helpModalComponent, onHelpClick } = useHelpLink(HELP_LINKS.MAIN);

  return (
    <div className={classnames(styles.modal, { safari10: isSafari10(window.navigator.userAgent) })}>
      <CustomModalLayout
        title={formatMessage({ id: 'common.header' })}
        closeButtonProps={{ onClick: onCancel }}
        helpButtonProps={{ onClick: onHelpClick }}
        dataHook="root-modal"
        overflowY="unset"
        removeContentPadding
      >
        <div className={styles.rootLayout}>{children}</div>
      </CustomModalLayout>
      {helpModalComponent}
    </div>
  );
};
